import { Avatar, Icon, UserIcon } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { getStoredImage } from '../../../../services/image';

interface UserAvatarProps {
  imageId?: string | null;
}

const UserAvatar: FC<UserAvatarProps> = ({ imageId }) => {
  const theme = useTheme();

  return imageId ? (
    <Avatar src={getStoredImage(imageId, 40)} />
  ) : (
    <Icon.Circle>
      <UserIcon color={theme.colors.darkergrey} />
    </Icon.Circle>
  );
};

UserAvatar.defaultProps = {
  imageId: undefined,
};

export default UserAvatar;
